import { Breakpoints } from '../types'

export const SCREEN_SIZES = {
  XS: `${Breakpoints.XS}px`,
  SM: `${Breakpoints.SM}px`,
  MD: `${Breakpoints.MD}px`,
  LG: `${Breakpoints.LG}px`,
  XL: `${Breakpoints.XL}px`,
  XXL: `${Breakpoints.XXL}px`
}
